/* @flow */

export enum ModalActionType {
  Disable, // Stop rendering all modals at once (used to temporarily hide everything [Chargebee's popup usecase])
  Enable, // Render again all modals
  Hide, // Close top modal
  Reopen, // Reopen saved modal
  SaveAndHide, // Save top modal and close it
  Show, // Show new modal
}
